module.exports = __webpack_public_path__ + "static/img/img3.c2aba98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/img3.png
// module id = E2JE
// module chunks = 1